module.exports = __webpack_public_path__ + "static/media/item_12_3_comp.f0ed8a98.png";